import Layout from '@/components/feature/Layout';
import { companyInfo } from '@/mocks/company';
import { Link } from 'react-router-dom';

const whatsappMessage = encodeURIComponent('Olá! Estou no site da Maquinasdesoldageomembrana.com.br e gostaria de informações sobre máquinas de solda de geomembrana.');
const whatsappUrl = `https://wa.me/${companyInfo.whatsapp}?text=${whatsappMessage}`;

const ctaSidebar = (
  <div className="bg-primary-50 rounded-2xl border border-primary-200/70 p-6 md:p-8">
    <h3 className="font-heading text-lg font-bold text-foreground-950 uppercase mb-3">Precisa de ajuda?</h3>
    <p className="text-foreground-500 text-sm leading-relaxed mb-5">
      Nossa equipe técnica responde em minutos pelo WhatsApp. Indicamos o equipamento ideal para seu projeto.
    </p>
    <a
      href={whatsappUrl}
      target="_blank"
      rel="nofollow noreferrer"
      className="w-full inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1ebe5d] text-white font-bold text-sm px-6 py-3 rounded-full transition-all cursor-pointer whitespace-nowrap uppercase tracking-wide"
    >
      <i className="ri-whatsapp-line" />
      Falar no WhatsApp
    </a>
    <div className="mt-4 text-center">
      <span className="text-foreground-400 text-xs">{companyInfo.phone}</span>
    </div>
  </div>
);

function PageBreadcrumb({ items }: { items: { label: string; to?: string }[] }) {
  return (
    <nav className="text-xs text-foreground-400 mb-6 flex items-center gap-2 flex-wrap">
      <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">Home</Link>
      {items.map((item, i) => (
        <span key={i} className="flex items-center gap-2">
          <i className="ri-arrow-right-s-line text-foreground-300" />
          {item.to ? (
            <Link to={item.to} className="hover:text-primary-600 transition-colors cursor-pointer">{item.label}</Link>
          ) : (
            <span className="text-foreground-600">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}

function RelatedLinks({ links }: { links: { to: string; label: string }[] }) {
  return (
    <div className="mt-8 md:mt-10">
      <h4 className="text-sm font-bold text-foreground-900 uppercase mb-3">Também consulte</h4>
      <div className="flex flex-wrap gap-2">
        {links.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium bg-primary-50 px-3 py-1.5 rounded-full transition-colors cursor-pointer"
          >
            {link.label} <i className="ri-arrow-right-line text-xs" />
          </Link>
        ))}
      </div>
    </div>
  );
}

export { ctaSidebar, PageBreadcrumb, RelatedLinks };